// 첨부 이미지 썸네일 그리드. 클릭 시 원본을 새 탭에서 연다.
// 빈 배열이면 안내문을 표시한다. objectFit: contain + aspectRatio 고정으로
// 페이지 가로 스크롤을 유발하지 않는다.

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { SxProps, Theme } from "@mui/material/styles";

export interface AttachmentItem {
  // 원본 슬롯 번호(attached1~7). alt 텍스트에 노출
  slot: number;
  url: string;
}

export interface AttachmentGalleryProps {
  items: AttachmentItem[];
  emptyText?: string;
  thumbSize?: number;
  sx?: SxProps<Theme>;
  className?: string;
}

export const AttachmentGallery: React.FC<AttachmentGalleryProps> = ({
  items,
  emptyText = "첨부된 파일이 없습니다.",
  thumbSize = 168,
  sx,
  className,
}) => {
  const clean = (items ?? []).filter((item) => item && item.url);

  if (clean.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: "text.disabled" }}>
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box
      className={className}
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${thumbSize}px, 1fr))`,
        gap: 1.5,
        ...sx,
      }}
    >
      {clean.map((item, index) => (
        <Box
          key={`${item.url}-${index}`}
          component="a"
          href={item.url}
          target="_blank"
          rel="noreferrer"
          sx={{
            display: "block",
            borderRadius: 1,
            overflow: "hidden",
            border: "1px solid",
            borderColor: "divider",
            transition: "border-color .15s",
            "&:hover": { borderColor: "primary.main" },
          }}
        >
          <Box
            component="img"
            src={item.url}
            alt={`첨부 ${item.slot}`}
            loading="lazy"
            sx={{
              width: "100%",
              aspectRatio: "4 / 3",
              objectFit: "contain",
              bgcolor: "grey.50",
              display: "block",
            }}
          />
        </Box>
      ))}
    </Box>
  );
};
